/* eslint-disable */
import { useEffect, useState } from "react";
import elbarco from "../../assets/titulos/elbarco.png";
import ship from "../../assets/titles/ship.png";
import "../../styles/BarcoPage.css";
import ImageGalleryModal from "../../components/ImageGalleryModal";
import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

import A7402072 from "../../assets/boatpics/berco/A7402072.jpg";
import A7402079 from "../../assets/boatpics/berco/A7402079.jpg";
import A7402090 from "../../assets/boatpics/berco/A7402090.jpg";
import A7402343 from "../../assets/boatpics/berco/A7402343.jpg";
import BARCO from "../../assets/boatpics/berco/BARCO.jpg";
import BARCO2 from "../../assets/boatpics/berco/BARCO2.jpg";

import A7402230 from "../../assets/boatpics/jacuzzi/A7402230.jpg";
import jacu from "../../assets/boatpics/jacuzzi/jacu.jpg";

import A7402299 from "../../assets/boatpics/kitchen/A7402299.jpg";
import cocina from "../../assets/boatpics/kitchen/cocina.jpg";

import A7402116 from "../../assets/boatpics/lounge/A7402116.jpg";
import A7402120 from "../../assets/boatpics/lounge/A7402120.jpg";
import A7402131 from "../../assets/boatpics/lounge/A7402131.jpg";
import A7402175 from "../../assets/boatpics/lounge/A7402175.jpg";
import A7402275 from "../../assets/boatpics/lounge/A7402275.jpg";
import A7402316 from "../../assets/boatpics/lounge/A7402316.jpg";

import A7401935 from "../../assets/boatpics/master1/A7401935.jpg";
import master1 from "../../assets/boatpics/master1/master1.jpg";
import master3 from "../../assets/boatpics/master1/master3.jpg";
import master11 from "../../assets/boatpics/master1/master11.jpg";
import masterb1 from "../../assets/boatpics/master1/masterb1.jpg";
import masterb2 from "../../assets/boatpics/master1/masterb2.jpg";

import masterblack1 from "../../assets/boatpics/master2/masterblack1.jpg";
import masterblack2 from "../../assets/boatpics/master2/masterblack2.jpg";
import masterblackb1 from "../../assets/boatpics/master2/masterblackb1.jpg";
import masterblackb2 from "../../assets/boatpics/master2/masterblackb2.jpg";

import A7402282 from "../../assets/boatpics/outdoordining/A7402282.jpg";
import A7402321 from "../../assets/boatpics/outdoordining/A7402321.jpg";
import A7402338 from "../../assets/boatpics/outdoordining/A7402338.jpg";
import A7402346 from "../../assets/boatpics/outdoordining/A7402346.jpg";

import A7402240 from "../../assets/boatpics/sundeck/A7402240.jpg";
import A7402365 from "../../assets/boatpics/sundeck/A7402365.jpg";

import twin1 from "../../assets/boatpics/twin/twin1.jpg";
import twin2 from "../../assets/boatpics/twin/twin2.jpg";

const imagenes = [A7402072, A7402079, A7402090, A7402343];

function BarcoPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();

  const zonas = [
    {
      nombre: "El Barco",
      label: t("zonas.barco.label"),
      descripcion: t("zonas.barco.descripcion"),
      isSlideshow: true,
      imagenes: [BARCO, BARCO2, A7402090, A7402343],
    },
    {
      nombre: "Habitaciones Matrimonio",
      label: t("zonas.matrimonio.label"),
      descripcion: t("zonas.matrimonio.descripcion"),
      isSlideshow: true,
      imagenes: [
        master1,
        master3,
        master11,
        masterblack1,
        masterblack2,
        masterb1,
        masterb2,
      ],
    },
    {
      nombre: "Habitaciones Twin",
      label: t("zonas.twin.label"),
      descripcion: t("zonas.twin.descripcion"),
      isSlideshow: true,
      imagenes: [twin1, twin2],
    },
    {
      nombre: "Salón y Comedor",
      label: t("zonas.salon.label"),
      descripcion: t("zonas.salon.descripcion"),
      isSlideshow: true,
      imagenes: [
        A7402116,
        A7402120,
        A7402131,
        A7402175,
        A7402316,
        masterblackb1,
        masterblackb2,
      ],
    },
    {
      nombre: "Cocina",
      label: t("zonas.cocina.label"),
      descripcion: t("zonas.cocina.descripcion"),
      isSlideshow: true,
      imagenes: [A7402299, cocina],
    },
    {
      nombre: "Comedor",
      label: t("zonas.comedor.label"),
      descripcion: t("zonas.comedor.descripcion"),
      isSlideshow: true,
      imagenes: [A7402282, A7402321, A7402338, A7402346],
    },
    {
      nombre: "Solárium",
      label: t("zonas.solarium.label"),
      descripcion: t("zonas.solarium.descripcion"),
      isSlideshow: true,
      imagenes: [A7402365, A7402240],
    },
    {
      nombre: "Flybridge con jacuzzi",
      label: t("zonas.flybridge.label"),
      descripcion: t("zonas.flybridge.descripcion"),
      isSlideshow: true,
      imagenes: [jacu, A7402230],
    },
  ];

  return (
    <div className="barco-hero fade-tab">
      <div className="menu-icon-div">
        <img src={menuIcon} />
      </div>
      <div className="barco-hero-content">
        <LocalizedTitleImage
          imageEn={ship}
          imageEs={elbarco}
          className="title-logob"
        />

        <button className="hero-button" onClick={() => setModalOpen(true)}>
          {t("zonas.ver.gal")}
        </button>
      </div>

      {modalOpen && (
        <ImageGalleryModal
          images={imagenes}
          currentIndex={currentIndex}
          onClose={() => setModalOpen(false)}
          setIndex={setCurrentIndex}
          zonas={zonas}
          modalActiveTab="El Barco"
          setModalActiveTab={() => {}}
        />
      )}
    </div>
  );
}

export default BarcoPage;
